import { MaintenanceAspectService } from './maintenance-aspect.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { MAINTENANCE_ASPECT_TYPE, MaintenanceAspect } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class MaintenanceAspectResolverBase implements Resolve<MaintenanceAspect> {

  constructor(protected service: MaintenanceAspectService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<MaintenanceAspect> {
    const key: number = MAINTENANCE_ASPECT_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



